module.exports = __webpack_public_path__ + "static/img/product_banner_32_zh.0e8fa94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_banner_32_zh.png
// module id = GUyK
// module chunks = 34